const allKeys = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890BackspaceCapLockEnterShift1Shift2- =Tab[]\'/` \\:,.;?!"@#$%^&*()+<>';

export default {
  activeLetters({ settings }) {
    return settings.keys || allKeys;
  }
};
